import { IMenuState } from './types';
import ActionTypes from '../../../constants/ActionTypes';
import { AnyAction } from 'redux';

const initialState: IMenuState = {
  items: [],
  visible: false,
  isLogin: false,
  isMenuOpen: false,
  id: 0,
};
const menuReducer = (
  state = initialState,
  action: AnyAction,
): IMenuState => {
  switch (action.type) {
  case ActionTypes.MENU.SET_ITEMS:
    return {
      ...state,
      items: action.payload.items,
      visible: action.payload.visible,
      isLogin: action.payload.isLogin,
      id: action.payload.id,
    };
  case ActionTypes.MENU.HIDE_MOBILE_SUBMENU_ITEMS:
    return {
      ...state,
      items: [],
      visible: action.payload.visible,
      isLogin: false,
    };
  case ActionTypes.MENU.SHOW_MOBILE:
    return {
      ...state,
      isMenuOpen: true,
    };
  case ActionTypes.MENU.HIDE_MOBILE:
    return {
      ...state,
      items: [],
      isMenuOpen: false,
      isLogin: false,
      visible: false,
    };
  }
  return state;
};

export default menuReducer;
